import { cn } from "@/utils";
import * as ToastPrimitives from "@radix-ui/react-toast";
import { cva, VariantProps } from "class-variance-authority";
import React from "react";

export const toastDescriptionVariant = cva([], {
  variants: {
    variant: {
      default: "text-gray-500",
      destructive: "text-yellow-500",
      success: " text-green-600",
      error: "text-red-500",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const ToastDescription = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Description>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Description> &
    VariantProps<typeof toastDescriptionVariant>
>(({ className, ...props }, ref) => (
  <ToastPrimitives.Description
    ref={ref}
    className={cn("text-sm opacity-90", className, toastDescriptionVariant(props))}
    {...props}
  />
));
ToastDescription.displayName = ToastPrimitives.Description.displayName;

export { ToastDescription };
